<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-sales-hold',
    }"
  >
    <h4 class="mt-6 mb-9">
      Glad you're here, {{ firstName }}!
    </h4>
    <p class="p3 mb-6">
      {{ companyName || 'Your company' }}'s contract has ended, but we're so happy
      you liked using Datapeople. (We loved having you!) Didn't mean to say goodbye to fair,
      efficient hiring? Get back in touch at
      <a
        :href="`mailto:${accountExecutiveEmail || 'hello@datapeople.io'}?subject=Billing%20expired`"
      >
        {{ accountExecutiveEmail || 'hello@datapeople.io' }}.
      </a>
    </p>
    <p class="p3">
      We can't wait to reconnect!
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'BillingExpired',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'companyName', 'accountExecutiveEmail']),
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Billing Expired' });
  },
};
</script>
